/** Header üstü kayan duyuru: CMS › Bildirimler varsa onlar, yoksa eski
 * `top_bar_message`. Altı kabuk da bu hook'u okur — ayrı ayrı yazılsaydı bir
 * şema CMS bildirimini görmezdi. */
import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import {
  MOBILE_QUERY, isMobileViewport, liveNotifications, notificationText,
} from './cmsPopups';
import { renderSettingText } from './textTemplate';

export const useMobileViewport = () => {
  const [mobile, setMobile] = useState(isMobileViewport);
  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const query = window.matchMedia(MOBILE_QUERY);
    const update = () => setMobile(query.matches);
    query.addEventListener?.('change', update);
    return () => query.removeEventListener?.('change', update);
  }, []);
  return mobile;
};

export const announcementText = (settings, { mobile = false, user = null, fallback = '' } = {}) => {
  const notes = liveNotifications(settings?.cms_notifications, { mobile, user });
  if (notes.length) {
    return notes.map((note) => renderSettingText(notificationText(note), settings).trim()).filter(Boolean).join('   •   ');
  }
  return renderSettingText(settings?.top_bar_message || fallback, settings || {}).trim();
};

const useAnnouncement = (settings, fallback = '') => {
  const mobile = useMobileViewport();
  const { user } = useAuth() || {};
  return announcementText(settings, { mobile, user, fallback });
};

export default useAnnouncement;
